import React, { useRef, useState } from "react";
import styles from "./Paintings.module.scss";
import ChevronIcon from "components/svgs/ChevronIcon";
import Checkbox from "components/checkbox/Checkbox";
import { useClickOutside } from "hooks/useClickOutside";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import { paintings } from "mockdata/paintings";

const sortBySizeOptions = [
  {
    label: "Large to Small",
    value: "large-to-small",
  },
  {
    label: "Small to Large",
    value: "small-to-large",
  },
];

const sortByPriceOptions = [
  {
    label: "High to Low",
    value: "high-to-low",
  },
  {
    label: "Low to High",
    value: "low-to-high",
  },
];

const Paintings = () => {
  const sortBySizeDropdownRef = useRef(null);
  const [selectedSortBySize, setSelectedSortBySize] = useState(null);
  const [showSortBySizeDropdown, setShowSortBySizeDropdown] = useState(false);

  useClickOutside(sortBySizeDropdownRef, () => {
    setShowSortBySizeDropdown(false);
    setShowSortByPriceDropdown(false);
  });

  const sortByPriceDropdownRef = useRef(null);
  const [selectedSortByPrice, setSelectedSortByPrice] = useState(null);
  const [showSortByPriceDropdown, setShowSortByPriceDropdown] = useState(false);

  useClickOutside(sortByPriceDropdownRef, () => {
    setShowSortBySizeDropdown(false);
    setShowSortByPriceDropdown(false);
  });

  return (
    <div className={`paintingsRef ${styles.artistPaintings}`}>
      <h2 className={styles.title}>Paintings</h2>
      <div className={styles.sortingContainer}>
        <div className={styles.sorting}>
          <div
            className={`${styles.label} ${
              showSortBySizeDropdown ? styles.open : ""
            }`}
            onClick={() => setShowSortBySizeDropdown(!showSortBySizeDropdown)}
          >
            <span>Sort by size</span>
            <ChevronIcon />
          </div>
          {showSortBySizeDropdown ? (
            <div className={styles.dropdown} ref={sortBySizeDropdownRef}>
              {sortBySizeOptions.map((option) => {
                return (
                  <Checkbox
                    key={option.value}
                    id={option.value}
                    label={option.label}
                    isChecked={option.value === selectedSortBySize}
                    setIsChecked={() => {
                      setSelectedSortBySize((prev) =>
                        option.value === prev ? null : option.value
                      );
                      setShowSortBySizeDropdown(false);
                      setShowSortByPriceDropdown(false);
                    }}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
        <div className={styles.sorting}>
          <div
            className={`${styles.label} ${
              showSortByPriceDropdown ? styles.open : ""
            }`}
            onClick={() => setShowSortByPriceDropdown(!showSortByPriceDropdown)}
          >
            <span>Sort by price</span>
            <ChevronIcon />
          </div>
          {showSortByPriceDropdown ? (
            <div className={styles.dropdown} ref={sortByPriceDropdownRef}>
              {sortByPriceOptions.map((option) => {
                return (
                  <Checkbox
                    key={option.value}
                    id={option.value}
                    label={option.label}
                    isChecked={option.value === selectedSortByPrice}
                    setIsChecked={() => {
                      setSelectedSortByPrice((prev) =>
                        option.value === prev ? null : option.value
                      );
                      setShowSortBySizeDropdown(false);
                      setShowSortByPriceDropdown(false);
                    }}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </div>

      <div className={styles.paintingList}>
        {paintings.map((painting) => {
          return <ArtworkCard item={painting} key={painting.id} />;
        })}
      </div>
      <div className={styles.loadMore}>
        <button>Load More</button>
      </div>
    </div>
  );
};

export default Paintings;
